import styled from "styled-components";

export const ConnectPageContainer = styled("div")`
   padding-top: 52px;
`;
